import { mockSuccess, MockArrayData } from "@redriver/cinnamon";

const NAMESPACE = "SCHEDULES/PRODUCT_SCHEDULE";

const ActionTypes = {
  GetProductSchedules: `${NAMESPACE}/GET_PRODUCT_SCHEDULES`,
  GetDeletedProductSchedules: `${NAMESPACE}/GET_DELETED_PRODUCT_SCHEDULES`,
};

const mockSchedules = new MockArrayData([
  {
    id: "1",
    applicableItems: [{ item: "B1" }, { item: "C1" }, { item: "S1" }],
    model: "KONICA MINOLTA C300I",
    type: "System",
    identifier: "AA22M569845625",
    status: "R",
    postcode: "KT19 1LS",
    consumablesExclusive: false,
    remoteServices: true,
    meterReadingCode: [
      { item: "B1-109" },
      { item: "C1-124" },
      { item: "S1-501" },
    ],
    cfaRef: 123456,
    ipsCode: "BC",
    ipsInsurance: "",
    vatCode: "EU",
    rrpCash: "",
    rrpPercent: "",
    meterCollectionFromQtr: "",
    meterCollectionFinalQtr: "",
    deleted: false,
    productNotes: "Machine swap out, was replaced by IN....",
  },
  {
    id: "2",
    applicableItems: [{ item: "B2" }, { item: "C1" }, { item: "S1" }],
    model: "KYOCERA TA C456",
    type: "System",
    identifier: "APOKDF029FNMFLK",
    status: "O",
    postcode: "KT19 1LS",
    consumablesExclusive: false,
    remoteServices: true,
    meterReadingCode: [
      { item: "B1-109" },
      { item: "C1-124" },
      { item: "S1-501" },
    ],
    cfaRef: 123456,
    ipsCode: "",
    ipsInsurance: "",
    vatCode: "",
    rrpCash: "",
    rrpPercent: "",
    meterCollectionFromQtr: "",
    meterCollectionFinalQtr: "",
    deleted: false,
    productNotes:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?",
  },
  {
    id: "3",
    applicableItems: [{ item: "B1" }, { item: "C1" }, { item: "S1" }],
    model: "KYOCERA TA C580I",
    type: "System",
    identifier: "39034FKSKIMFSOM",
    status: "U",
    postcode: "KT19 1LS",
    consumablesExclusive: false,
    remoteServices: true,
    meterReadingCode: [
      { item: "B1-109" },
      { item: "C1-124" },
      { item: "S1-501" },
    ],
    cfaRef: 123456,
    ipsCode: "IP",
    ipsInsurance: "",
    vatCode: "EU",
    rrpCash: "",
    rrpPercent: "",
    meterCollectionFromQtr: "",
    meterCollectionFinalQtr: "",
    deleted: false,
    productNotes: "",
  },
  {
    id: "4",
    applicableItems: [{ item: "L1" }, { item: "P1" }, { item: "SS1" }],
    model: "CANON TX-3000",
    type: "System",
    identifier: "",
    status: "N",
    postcode: "KT19 1LS",
    consumablesExclusive: false,
    remoteServices: true,
    meterReadingCode: [
      { item: "B1-109" },
      { item: "C1-124" },
      { item: "S1-501" },
    ],
    cfaRef: 123456,
    ipsCode: "BC",
    ipsInsurance: "",
    vatCode: "S",
    rrpCash: "",
    rrpPercent: "",
    meterCollectionFromQtr: "",
    meterCollectionFinalQtr: "",
    deleted: false,
    productNotes: "",
  },
  {
    id: "5",
    applicableItems: [{ item: "L1" }, { item: "P1" }],
    model: "CANON TX-2001",
    type: "System",
    identifier: "47645674GDGGRER",
    status: "R",
    postcode: "KT19 1LS",
    consumablesExclusive: false,
    remoteServices: true,
    meterReadingCode: [
      { item: "B1-109" },
      { item: "C1-124" },
      { item: "S1-501" },
    ],
    cfaRef: 123456,
    ipsCode: "CC",
    ipsInsurance: "",
    vatCode: "S",
    rrpCash: "",
    rrpPercent: "",
    meterCollectionFromQtr: "",
    meterCollectionFinalQtr: "",
    deleted: false,
    productNotes: "Machine swap out, was replaced by IN....",
  },
  {
    id: "6",
    applicableItems: [],
    model: "PAPERCUT",
    type: "Software",
    identifier: "",
    status: "N",
    postcode: "KT19 1LS",
    consumablesExclusive: null,
    remoteServices: true,
    meterReadingCode: [],
    cfaRef: 123456,
    ipsCode: "BC",
    ipsInsurance: "",
    vatCode: "S",
    rrpCash: "",
    rrpPercent: "",
    meterCollectionFromQtr: "",
    meterCollectionFinalQtr: "",
    deleted: false,
    productNotes: "",
  },
  {
    id: "7",
    applicableItems: [{ item: "L1" }, { item: "P1" }, { item: "SS1" }],
    model: "CANON TX-2001",
    type: "System",
    identifier: "47645674GDGGRER",
    status: "R",
    postcode: "KT19 1LS",
    consumablesExclusive: false,
    remoteServices: true,
    meterReadingCode: [
      { item: "B1-109" },
      { item: "C1-124" },
      { item: "S1-501" },
    ],
    cfaRef: 123456,
    ipsCode: "BC",
    ipsInsurance: "",
    vatCode: "S",
    rrpCash: "",
    rrpPercent: "",
    meterCollectionFromQtr: "",
    meterCollectionFinalQtr: "",
    deleted: true,
    productNotes: "Machine swap out, was replaced by IN....",
  },
]);

export const getProductSchedules = ({ pagination }) => {
  const { pageSize, pageNumber } = pagination;
  return mockSuccess(ActionTypes.GetProductSchedules, {
    delay: 200,
    response: mockSchedules.filterPaged(
      (u) => !u.deleted,
      pageSize,
      pageNumber
    ),
  });
};

export const getDeletedProductSchedules = ({ pagination }) => {
  const { pageSize, pageNumber } = pagination;
  return mockSuccess(ActionTypes.GetProductSchedules, {
    delay: 200,
    response: mockSchedules.filterPaged((u) => u.deleted, pageSize, pageNumber),
  });
};
